import React from "react";

import { Timeline, Collapse } from "antd";

import { AppointmentItem } from "./AppointmentItem";

export const AppointmentList = ({ title, appointments, timeOfDay }) => {
  return (
    <Collapse
      className="appointment-section w-[70%]"
      expandIconPosition="end"
      defaultActiveKey={[timeOfDay]}
      ghost
      items={[
        {
          key: timeOfDay,
          label: (
            <span
              style={{ margin: 0 }}
              className={`!text-lightText font-inter text-[14px] leading-[20px] font-medium`}
            >
              {title}
            </span>
          ),
          children: (
            <div>
              {appointments.length > 0 ? (
                <Timeline
                  mode="left"
                  items={appointments.map((appointment) => ({
                    color:
                      appointment?.status === "in-progress"
                        ? "#0076FF"
                        : "#CDCDCD",
                    children: <AppointmentItem appointment={appointment} />,
                  }))}
                />
              ) : (
                <div className="bg-[#CDCDCD26] text-lightText px-4 py-0.5 rounded-sm text-center">
                  You have no scheduled sessions
                </div>
              )}
            </div>
          ),
        },
      ]}
    />
  );
};
